import { render, staticRenderFns } from "./classOpenServiceTwo2.vue?vue&type=template&id=2019e4ce&"
import script from "./classOpenServiceTwo2.vue?vue&type=script&lang=ts&"
export * from "./classOpenServiceTwo2.vue?vue&type=script&lang=ts&"
import style0 from "./classOpenServiceTwo2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports